function generateOpenSettings (opts) {
	const defaults = {
		top: 0,
		left: 0,
		width: 500,
		height: 500,
	}

	const settings = { ...defaults, ...opts };

	return `width=${settings.width},height=${settings.height},left=${settings.left},top=${settings.top},toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menubar=0`;
}

export default function (els, opts) {
	els.forEach(el => {
		el.addEventListener('click', (e) => {
			e.preventDefault();

			window.open(
				el.href,
				el.name,
				generateOpenSettings(opts),
			).focus();
		});
	});
}
